import React, { useState, useEffect, useCallback } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import config from '../../config'
import Cookies from 'js-cookie'
import { Spinner } from 'react-bootstrap'

const ViewOrder = ({ showViewOrder, setShowViewOrder, userIdOrPhone }) => {
  const [loading, setLoading] = useState(false)
  const [order, setOrder] = useState([])
  const [rounds, setRounds] = useState([])
  const [roundDate, setRoundDate] = useState()
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const fetchOrders = useCallback(async (page, userId, roundDate) => {
    setLoading(true)

    try {
      const params = new URLSearchParams()
      params.append('userNo', userId)
      params.append('status', 'SUCCESS')
      params.append('roundDate', roundDate || '')
      params.append('sort', 'DESC')
      params.append('page', page)
      params.append('limit', 10)

      const headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)

      const response = await fetch(`${config.apiAdminGateway}/api/v3/admin/orders?${params.toString()}`, {
        headers: headers,
      }).then((res) => res.json())

      setPagination((pagination) => ({
        ...pagination,
        hasNext: response.pagination.hasNext,
      }))
      setOrder(response.data)
    } catch (error) {
      setOrder([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchOrders(pagination.page, userIdOrPhone, roundDate)
  }, [pagination.page, fetchOrders, userIdOrPhone, roundDate])

  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/rounds`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        setRounds(response.data)
      } catch (error) {
        setRounds([])
      }
    }

    fetchRounds()
  }, [])

  const handleChangeRoundDate = (event) => {
    setPagination((pagination) => ({ ...pagination, page: 1 }))
    setRoundDate(event.target.value)
  }

  const orderStatus = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'รอแจ้งโอน'
      case 'confirmed':
        return 'แจ้งโอนแล้ว'
      case 'success':
        return 'ซื้อสำเร็จ'
      case 'cancel':
        return 'ยกเลิก'

      default:
        break
    }
  }

  return (
    <Modal className="fade" show={showViewOrder} size="xl">
      <Modal.Header>
        <Modal.Title>ลูกค้า: {userIdOrPhone}</Modal.Title>
        <Button variant="" className="close" onClick={() => setShowViewOrder(false)}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingBottom: '8px' }}>
          <span>งวดที่ :</span>
          <select
            style={{ padding: '8px', borderRadius: '8px', fontSize: '14px' }}
            value={roundDate}
            onChange={handleChangeRoundDate}
          >
            <option value="">ทั้งหมด</option>
            {rounds.map((item, i) => {
              return (
                <option key={i} value={item.value}>
                  {item.value}
                </option>
              )
            })}
          </select>
        </Modal.Title>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : order.length > 0 ? (
          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                <th>เลขที่คำสั่งซื้อ</th>
                <th>วันที่ซื้อ</th>
                <th>ลูกค้า</th>
                <th>สถานะคำสั่งซื้อ</th>
                <th>ราคา</th>
                <th>ค่าบริการฝากสลาก</th>
                <th>ราคารวม</th>
              </tr>
            </thead>
            <tbody>
              {order.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{item.orderNo}</td>
                    <td>
                      {new Date(item.createdAt).toLocaleDateString('TH-th')}{' '}
                      {new Date(item.createdAt).toLocaleTimeString('TH-th')}
                    </td>
                    <td>
                      {item.user.firstName} {item.user.lastName}
                    </td>
                    <td>{orderStatus(item.status)}</td>
                    <td>{item.price ? item.price.toLocaleString() : item.price}</td>
                    <td>{item.fee}</td>
                    <td>{item.totalPrice ? item.totalPrice.toLocaleString() : item.totalPrice}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        ) : (
          <h1 className="text-center">ไม่มี ORDER</h1>
        )}

        <div style={{ textAlign: 'right', marginTop: 15 }}>
          {pagination.page > 1 && (
            <Button
              variant="primary light"
              onClick={() => setPagination((pagination) => ({ ...pagination, page: pagination.page - 1 }))}
            >
              {'<'} หน้าก่อนหน้า
            </Button>
          )}{' '}
          <Button variant="primary light">{pagination.page}</Button>{' '}
          {pagination.hasNext && (
            <Button
              variant="primary light"
              onClick={() => setPagination((pagination) => ({ ...pagination, page: pagination.page + 1 }))}
            >
              หน้าถัดไป {'>'}
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ViewOrder
